<template>
  <div>
    <el-row style="font-size: 24px;font-weight: bold;text-align: center;">
      <el-col>{{data.title}}</el-col>
    </el-row>
    <el-row style="margin-top: 20px;text-align: center;">
      <el-col>发布日期：{{data.releaseTime}}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;发布单位：{{data.releaseUnit}}</el-col>
    </el-row>
    <el-row>
      <el-col>
        <el-divider></el-divider>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="text-indent: 40px" :span="22" :offset="1">
        <div v-html="data.content">
      
        </div>
        </el-col>
    </el-row>
  </div>
</template>
<script>
import request from "../../../utils/request";

export default {
  name:'announceDetail',
  props:{
    id:{
      type:String,
      required:true
    }
  },
  data(){
    return{
      data:{},
    }
  },
  methods:{
    getData(){
      request({
        url:'portalController/getAnnouncementById',
        methods: 'get',
        params:{
          id:this.id
        }
      }).then(rsp=>{
        if(rsp.resultCode==='0'){
          this.data=rsp.data
        }else {
          this.$message({
            message:'公示公告查看详情错误',
            type:'error',
            duration:1500
          })
        }
      })
    }
  },
  mounted(){
    this.getData();
  }
}
</script>
<style scoped>
.el-divider--horizontal{
  margin:10px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/home/compoment/announceDetail.vue